import * as React from 'react';
import { useSelector } from 'react-redux';

import { MORTGAGE_PROMO_TYPES } from 'shared/constants/newbuildingPromos';
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { CallButton } from '../../../components/NewbuildingPromos/parts/PromoDetailsModal';
import { getDynamicCalltrackingSiteBlockId } from '../../../selectors/getDynamicCalltrackingSiteBlockId';
import { getGaLabel, getOfferPhones } from '../../../selectors/newObject';
import { IPromoInfo } from '../../../types/newbuildingPromos';
import { getFormattedPhoneNumber } from '../../../utils/formatters';
import { trackPhoneOpen, TTrackPhoneOpenAction } from '../../../utils/tracking/promos/trackPhoneOpen';
import { getCallButtonText } from '../helpers';

interface ICallButtonContainerProps {
  offer: IOfferSchema;
  promo: IPromoInfo;
}

export const CallButtonContainer: React.FC<ICallButtonContainerProps> = ({ offer, promo }) => {
  const [phonesVisible, handlePhonesVisible] = React.useState(false);

  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const gaLabel = useSelector(getGaLabel);
  const phones = useSelector(getOfferPhones);

  const phone = React.useMemo(() => (phones[0] ? getFormattedPhoneNumber(phones[0]) : ''), [phones]);

  const handleShowPhoneClick = React.useCallback(() => {
    handlePhonesVisible(true);
    let action: TTrackPhoneOpenAction = 'Open_card_promotions';
    if (MORTGAGE_PROMO_TYPES.includes(promo.promoType)) {
      action = 'Open_card_mortgage';
    }

    trackPhoneOpen({
      label: gaLabel,
      useLastProducts: false,
      action,
      offer,
      siteBlockId,
      promo,
    });
  }, [gaLabel, offer, promo, siteBlockId]);

  return (
    <CallButton
      buttonText={getCallButtonText(offer)}
      handleShowPhoneClick={handleShowPhoneClick}
      isPhonesVisible={phonesVisible}
      phone={phone}
      announcementId={offer.id}
      siteBlockId={siteBlockId}
      fullWidth
    />
  );
};
